import sajek from "../Image/Sajek.png"
import Sreemongol from "../Image/Sreemongol.png"
import sundorbon from "../Image/sundorbon.png"
import coxbazar from "../Image/coxbazar.png"

const travelData = [

    {
        "placeName": `Sajek Valley`,
        "image": `${sajek}`,
        "key": "SJKS001",
        "shortDescp": "The name of Sajek Valley came from the Sajek River that originates from Karnafuli river...",
        "description": "Sajek is a union located in the north of Chittagong Hill Tracts. It's under Baghaichori Upazila in Rangamati hill district, it is situated 67 kilometres (42 mi) north-east from Khagrachhari town and 95 kilometres (59 mi) north from Rangamati city. The border of Bangladesh and Mizoram of India is 8 kilometres (5.0 mi) east from Sajek.",
    },
    {
        "placeName": `Sreemangal`,
        "image": `${Sreemongol}`,
        "key": "SRMG001",
        "shortDescp": "Srimongol Cha Nilam Kendro) is the second tea auction center in Bangladesh,[1] which is located in Sreemangal Upazila...",
        "description": "In 1849, by establishing the Mulnichhera tea estate in Sylhet, British Hardson established the first tea garden in the subcontinent.[3] There are 164 tea gardens in Bangladesh, among them 135 tea gardens are located in Greater Sylhet. Of which, 92 gardens are located only in Moulvibazar District.[4] Moreover, there are 20 tea gardens in Sylhet district and 22 in Habiganj district.[3] But the tea produced in the gardens of Greater Sylhet was to be sent to Chittagong Tea Auction. ",
    },
    {
        "placeName": `Sundarban`,
        "image": `${sundorbon}`,
        "key": "SUNB005",
        "shortDescp": "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal....",
        "description": "The history of the area can be traced back to 200–300 AD. A ruin of a city built by Chand Sadagar has been found in the Baghmara Forest Block. During the Mughal period, the Mughal Emperors leased the forests of the Sundarbans to nearby residents. Many criminals took refuge in the Sundarbans from the advancing armies of Emperor Akbar. Many have been known to be attacked by tigers.[14] Many of the buildings which were built by them later fell to hands of Portuguese pirates.",
    },
    {
        "placeName": `Cox's bazar`,
        "image": `${coxbazar}`,
        "key": "COXBZ009",
        "shortDescp": "Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ....",
        "description": "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
    },


]


export default travelData;